import Modal from 'styled-react-modal'

const StyledModal = Modal.styled(({ theme }) => ({
  backgroundColor: theme.colors.grayscale.white,
  borderRadius: '8px',
  display: 'flex',
  flexGrow: 1,
  flexShrink: 0,
  flexBasis: '100%',
  flexDirection: 'column',
  height: 'fit-content',
  // offset top of modal by layout header height
  marginTop: '64px',
  maxHeight: 'calc(100% - 64px)',
  maxWidth: '416px',
  overflowX: 'hidden',
  overflowY: 'auto',
  paddingBottom: '30px',
}))

export default StyledModal
